module.exports = __webpack_public_path__ + "h5/img/fault.1670451a.png";